module.exports = __webpack_public_path__ + "static/media/secure-data.4a4fa231.jpg";